var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecklistFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m5.167 16.95 3.627-3.734a.92.92 0 0 1 .716-.302q.408.013.715.329.28.315.28.736 0 .42-.28.736l-4.317 4.47a.967.967 0 0 1-1.43 0L2.28 16.923A1.01 1.01 0 0 1 2 16.187q0-.447.281-.736a.95.95 0 0 1 .715-.29q.435 0 .715.29zm0-8.414 3.627-3.733A.92.92 0 0 1 9.51 4.5q.408.013.715.328.28.316.28.736t-.28.737l-4.317 4.47a.967.967 0 0 1-1.43 0L2.28 8.51A1.01 1.01 0 0 1 2 7.774q0-.448.281-.736a.95.95 0 0 1 .715-.29q.435 0 .715.29zm8.66 9.281q-.435 0-.729-.302a1.03 1.03 0 0 1-.293-.75q0-.446.293-.749a.98.98 0 0 1 .728-.302h7.152q.434 0 .728.302.294.303.294.75t-.294.749a.98.98 0 0 1-.728.302zm0-8.413q-.435 0-.729-.302a1.03 1.03 0 0 1-.293-.75q0-.446.293-.749a.97.97 0 0 1 .728-.302h7.152q.434 0 .728.302t.294.75-.294.749a.97.97 0 0 1-.728.302z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistFill);
export default __webpack_public_path__ + "static/media/checklist_fill.b92377156b9f120fb803a8fa0afe354f.svg";
export { ForwardRef as ReactComponent };